import React from 'react';
import { TreeSelect } from 'antd';
import {
  ModulesDefinition,
  settingsModulesList,
  newsModulesList,
  contentSettingsModulesList,
  knowledgeModulesList,
  contactModulesList,
  FertilizersModulesList,
  gtwModulesList,
  GardenModulesList,
} from 'enums/modulesDefinition';

const { TreeNode } = TreeSelect;

export const mapModules = (el: {
  title: string;
  id: ModulesDefinition;
}): JSX.Element => {
  switch (el.id) {
    case ModulesDefinition.usersSettings:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {settingsModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.contentSettings:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {contentSettingsModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.gtw:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {gtwModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.news:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {newsModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.knowledge:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {knowledgeModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.contact:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {contactModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.fertilizers:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {FertilizersModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.garden:
      return (
        <TreeNode
          value={el.id}
          title={el.title}
          checkable={false}
          disableCheckbox
        >
          {GardenModulesList.map((it) => (
            <TreeNode value={it.id} title={it.title} key={it.id} />
          ))}
        </TreeNode>
      );
    case ModulesDefinition.banners:
      return <TreeNode value="banners" title={el.title} key="banners" />;
    default:
      return <></>;
  }
};
